import React, { useContext, useState, useEffect } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import Utility from '../../../Utility';
import { Link } from "react-router-dom";
import { Icon, Card, Statistic, Header } from 'semantic-ui-react';

/**
 * Components AddBooking
 * Widget pour le dashboard
 */
//const AddBooking = props => {
const AddBooking = ({setActiveItemMenu}) => {
  
  const [globalContext] = useContext(GlobalContext);
  const siteMap = Utility.getSiteMap(globalContext.translations);
  const [isMultiEtabState, setIsMultiEtabState] = useState(false);  

  let langIso = localStorage.getItem('lang');
  if (langIso === 'EN') {
    langIso = 'UK';
  }
  let filteredObjLang = {};
  if (globalContext?.languages !== undefined) {
    filteredObjLang = globalContext.languages.find(objLang => {
      return objLang.iso === langIso
    });
  }
  let langBe = Object.keys(filteredObjLang).length > 0 ? filteredObjLang.name : langIso;

  let linkBe = ``;
  let bookingEngineLinkProps = {};

  /*if( globalContext.establishment?.customLinkBeActif && globalContext.establishment?.customLinkBe != "" ){
              setCardAddBookingCustomLinkState( globalContext.establishment?.customLinkBe );
            }*/
  // eslint-disable-next-line
  if( globalContext.establishment?.customLinkBeActif && globalContext.establishment?.customLinkBe != "" ){
    linkBe = `${globalContext.establishment?.customLinkBe}`;
  }
  else{
    linkBe = Utility.getBookingEngineUrl(globalContext.establishment.bookingEngineId, langBe);
    bookingEngineLinkProps = Utility.getBookingEngineLinkProps(globalContext.establishment.bookingEngineId, linkBe);
  }

  // gestion multi etab
  useEffect(() => {
    if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
      setIsMultiEtabState( true );
    }
  }, [globalContext.establishment.id])

  

  return (
    <>

    { isMultiEtabState ? 
      <Card
        centered
        as={Link}
        to={{
          pathname: `${Utility.getUrlBaseName()}/${siteMap.establishment.codePage}`
        }}
        onClick={() => setActiveItemMenu(siteMap.establishment.codePage)}
      >
        <Card.Header>
          <Header className="p-5" textAlign="center" as="h3" icon>
            <Statistic size="mini" color="red">
              <Statistic.Value><Icon color="blue" name="add circle" /></Statistic.Value>
              <Statistic.Label className="mt-4">{globalContext.translations.addBooking}</Statistic.Label>
            </Statistic>
          </Header>
        </Card.Header>
        <Card.Content textAlign="center" extra style={{ height: 58 }}>
          <div style={{ marginTop: 7 }}>
            {globalContext.translations.addBookingMessage}
          </div>
        </Card.Content>
      </Card>
      : 
      <Card centered as="a" target="_blank" href={linkBe} {...bookingEngineLinkProps} style={{ background: 'white', height: "300px" }}>
        <Card.Header>
          <Header className="p-5" textAlign="center" as="h3" icon>
            <Statistic size="mini" color="red">
              <Statistic.Value><Icon color="blue" name="add circle" /></Statistic.Value>
              <Statistic.Label className="mt-4">{globalContext.translations.addBooking}</Statistic.Label>
            </Statistic>
          </Header>
        </Card.Header>
        <Card.Content textAlign="center" extra style={{ height: 58 }}>
          <div style={{ marginTop: 7 }}>
            {globalContext.translations.addBookingMessage}
          </div>
        </Card.Content>
      </Card>
    }
     
    </>
  )
}

export default AddBooking;